<template>
  <v-slide-group
    v-model="iconSelection"
    selected-class="bg-success"
    mandatory
    show-arrows
    @update:modelValue="onIconChanged"
  >
    <v-slide-group-item
      v-for="icon in this.icons"
      :key="icon"
      v-slot="{ toggle, selectedClass }"
    >
      <v-card
        :class="['ma-2', selectedClass]"
        height="128"
        width="128"
        @click="toggle"
      >
        <v-img :src="this.getIconPath(icon)"></v-img
      ></v-card>
    </v-slide-group-item>
  </v-slide-group>
</template>

<script>
export default {
  props: {
    icons: {
      type: Array,
      require: true,
    },
  },
  data() {
    return {
      iconSelection: 0,
    };
  },
  methods: {
    getIconPath(icon_id) {
      return require("../assets/icons/emoji_" + icon_id + ".png");
    },
    onIconChanged() {
      var icon_id = this.icons[this.iconSelection];
      this.$emit("iconChanged", icon_id);
    },
  },
};
</script>
